/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    TransactionPartImpl,
    TransactionPartImplFromJSON,
    TransactionPartImplFromJSONTyped,
    TransactionPartImplToJSON,
} from './TransactionPartImpl';

/**
 * 
 * @export
 * @interface RegisterTransactionsDTO
 */
export interface RegisterTransactionsDTO {
    /**
     * 
     * @type {string}
     * @memberof RegisterTransactionsDTO
     */
    cardTypeId?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterTransactionsDTO
     */
    careProviderId?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterTransactionsDTO
     */
    carePrincipalId?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterTransactionsDTO
     */
    careUnitId?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterTransactionsDTO
     */
    personId?: string;
    /**
     * 
     * @type {Array<TransactionPartImpl>}
     * @memberof RegisterTransactionsDTO
     */
    transactionParts?: Array<TransactionPartImpl>;
}

export function RegisterTransactionsDTOFromJSON(json: any): RegisterTransactionsDTO {
    return RegisterTransactionsDTOFromJSONTyped(json, false);
}

export function RegisterTransactionsDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegisterTransactionsDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'cardTypeId': !exists(json, 'cardTypeId') ? undefined : json['cardTypeId'],
        'careProviderId': !exists(json, 'careProviderId') ? undefined : json['careProviderId'],
        'carePrincipalId': !exists(json, 'carePrincipalId') ? undefined : json['carePrincipalId'],
        'careUnitId': !exists(json, 'careUnitId') ? undefined : json['careUnitId'],
        'personId': !exists(json, 'personId') ? undefined : json['personId'],
        'transactionParts': !exists(json, 'transactionParts') ? undefined : ((json['transactionParts'] as Array<any>).map(TransactionPartImplFromJSON)),
    };
}

export function RegisterTransactionsDTOToJSON(value?: RegisterTransactionsDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'cardTypeId': value.cardTypeId,
        'careProviderId': value.careProviderId,
        'carePrincipalId': value.carePrincipalId,
        'careUnitId': value.careUnitId,
        'personId': value.personId,
        'transactionParts': value.transactionParts === undefined ? undefined : ((value.transactionParts as Array<any>).map(TransactionPartImplToJSON)),
    };
}

